import Dexie, { type Table } from "dexie";
import type { ComparisonRecord } from "./comparison.types";

class ComparisonDatabase extends Dexie {
  comparisons!: Table<ComparisonRecord, number>;

  constructor() {
    super("AfinaStatisticsComparisons");
    // Auto-incrementing `id` primary key; `createdDate` is indexed so the list
    // can be ordered by when each comparison was made.
    this.version(1).stores({
      comparisons: "++id, createdDate",
    });
  }
}

export const comparisonDB = new ComparisonDatabase();
